import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const queryFnEnergyCostCard = (
    accessToken: string,
    data: {
        reportFiltersetUid: string | null;
    }
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            reportFiltersetUid: data.reportFiltersetUid,
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) =>
        data.prefilteredReports?.prefilteredBaselineReport.currentAnnualEnergyCostCard || null
    );

const query = graphql(`
    query currentAnnualEnergyCostCard($reportFiltersetUid: Uuid) {
        prefilteredReports(reportFiltersetUid: $reportFiltersetUid) {
            prefilteredBaselineReport {
                currentAnnualEnergyCostCard {
                    totalEnergyCost
                    landlordEnergyCost
                    tenantEnergyCost
                }
            }
        }
    }
`);

export default queryFnEnergyCostCard;
